module.exports = __webpack_public_path__ + "static/media/albion_alba_eba_icon_small.82e998f2.png";